import React from 'react';
import { createRoot } from 'react-dom/client';
import FeatureFlagsProvider from './common/featureFlags/FeatureFlagsProvider';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

(async () => {
  const FeatureFlagsHarnessProvider = await FeatureFlagsProvider();
  root.render(
    <FeatureFlagsHarnessProvider>
      <App />
    </FeatureFlagsHarnessProvider>
  );
})();
